import { render, staticRenderFns } from "./QuoteRichModule.vue?vue&type=template&id=c66159a2&"
import script from "./QuoteRichModule.ts?vue&type=script&lang=ts&"
export * from "./QuoteRichModule.ts?vue&type=script&lang=ts&"
import style0 from "./QuoteRichModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports